import { apiAuth, apiResponseType } from ".";

/**
 * Logs de ações de negócio (LOT-19): quem criou, editou, cancelou, finalizou ou
 * excluiu concursos, criou apurações e solicitou/aprovou/recusou/executou
 * cancelamentos de vendas e pré-vendas.
 *
 * Diferente de `logs.ts`, que é o log técnico de requests/erros.
 */

export type ActionLogModule = "contests" | "sales";

export type ActionLogEntityType = "contest" | "sale";

export type ActionLogSortColumn =
  | "created_at"
  | "user_name"
  | "action"
  | "entity_label"
  | "description"
  | "ip_address";

export interface ActionLogFilters {
  log_action_id?: string;
  module?: ActionLogModule | "";
  user_id?: string;
  seller_id?: string;
  unity_id?: string;
  entity_type?: ActionLogEntityType | "";
  search?: string;
  date_start?: string;
  date_end?: string;
  per_page?: number;
  order_by?: ActionLogSortColumn;
  order_direction?: "asc" | "desc";
}

const buildQuery = (page: number, filters: ActionLogFilters) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, String(value));
    }
  });

  return params.toString();
};

export const getActionLogs = (
  page: number = 1,
  filters: ActionLogFilters = {}
): apiResponseType => apiAuth.get(`action-logs?${buildQuery(page, filters)}`);

export const getActionLogOptions = (): apiResponseType =>
  apiAuth.get("action-logs/options");

export const getActionLogDetail = (uuid: string): apiResponseType =>
  apiAuth.get(`action-logs/${uuid}/show`);
